const About = () => {
  return (
    <section id="description" class="section">
      <div class="anchorref" id="1"></div>
      <div class="container">
        <h2 class="section-title">Who We Are</h2>
        <p>
          Our mission at Midwest Packaging Partners is to provide high-quality
          packaging supplies with a strong focus on exceptional customer service
          and competitive pricing. We strive to be a reliable and trusted
          partner for businesses of all sizes, offering a wide range of
          packaging solutions to meet their unique needs. Our goal is to help
          our customers succeed by providing them with the best products and
          services, delivered promptly and efficiently. We are committed to
          building long-lasting relationships with our clients and being a
          valuable resource in their packaging processes.
        </p>
      </div>
    </section>
  );
};

export default About;
